/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import userJson from "../../../public/user.json";
import axios from "axios";
import router from '../../router'
import state from "../state"
export default {
	listCustomerinfoForRole({ getters, commit, dispatch }, item) {
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
				dispatch("listCustomerInfoForCustomer", item).then(response => {
					resolve(response);
				})
			}
			else if (state.AppActiveUser.ROLE == "Company") dispatch("listCustomerInfoForCustomer", state.AppActiveUser.companyid).then(response => {
				resolve(response);
			})
		})
	},
	updateCustomer({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.put(sistemAddress + "api/uzumservice/Company/update/company", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						commit("DELETE_ITEM_COMPANY", item.companyId)
						commit("ADD_ITEM_COMPANY", item)
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	updateCustomerInfo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.put(sistemAddress + "api/uzumservice/Company/update/companyinfo", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	addCustomer({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.post(sistemAddress + "api/uzumservice/Company/add/company", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						commit("ADD_ITEM_COMPANY", item)
						resolve(response);
					})
					.catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						}
						resolve(err.response);
					});
		});
	},
	addCustomerInfo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.post(sistemAddress + "api/uzumservice/Company/add/companyinfo", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	addCustomerAct({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.post(sistemAddress + "api/uzumservice/Company/add/companytrans", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	deleteCustomerAct({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Company/delete/companytrans/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => { 
					resolve(response);
				})
				.catch(err => {

					resolve(err.response);
				});
		});
	},
	updateCustomerAct({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {

			axios
				.put(sistemAddress + "api/uzumservice/Company/update/companytrans", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listPaymentType({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		console.log(token)
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/Company/peymenttypelist", {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = response.data;
							commit("PAYMENT_LIST", item);
							resolve(response);
						} else if (response == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							commit("PAYMENT_LIST", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listCustomerActForCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/Company/list/companytrasn/" + item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							commit("CUSTOMERACT_LIST", item);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							commit("CUSTOMERACT_LIST", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listCustomerAct({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
						axios.get(sistemAddress + "api/uzumservice/Company/list/companytrans", {
							headers: {
								Authorization: `Bearer ${token}`,
								token: token
							}
						}).then(response => {
							if (response.status == 200) {
								item = JSON.parse(response.data.json);
								commit("CUSTOMERACT_LIST", item);
								resolve(response.data);
							} else if (response.status == 401) {
								router.push("/login")
							}
						}).catch(err => {
							if (err.response.status == 401) {
								router.push("/login")
							} else if (err.response.status == 400) {
								commit("CUSTOMERACT_LIST", []);
							}
							resolve(err.response);
						});
					}
				});
			} catch (error) {

			}

	},
	listCustomerActBalance({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
						axios.get(sistemAddress + "api/uzumservice/Company/list/companytransbalance/" + item, {
							headers: {
								Authorization: `Bearer ${token}`,
								token: token
							}
						}).then(response => {
							if (response.status == 200) {
								item = JSON.parse(response.data.json);
								commit("CUSTOMERACT_BALANCE", item);
								resolve(response.data);
							} else if (response.status == 401) {
								router.push("/login")
							}
						}).catch(err => {
							if (err.response.status == 401) {
								router.push("/login")
							} else if (err.response.status == 400) {
								commit("CUSTOMERACT_BALANCE", []);
							}
							resolve(err.response);
						});
					}
				});
			} catch (error) {

			}

	},
	listCustomer({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
						axios.get(sistemAddress + "api/uzumservice/Company/list/company", {
							headers: {
								Authorization: `Bearer ${token}`,
								token: token
							}
						}).then(response => {
							if (response.status == 200) {
								item = JSON.parse(response.data.json);
								commit("CUSTOMER_LIST", item);
								resolve(response.data);
							} else if (response.status == 401) {
								router.push("/login")
							}
						}).catch(err => {
							if (err.response.status == 401) {
								router.push("/login")
							} else if (err.response.status == 400) {
								commit("CUSTOMER_LIST", []);
							}
							resolve(err.response);
						});
					}
				});
			} catch (error) {

			}

	},
	listCustomerInfo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios.get(sistemAddress + "api/uzumservice/Company/list/companyinfo", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				}).then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("CUSTOMER_INFO_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login")
					}
				}).catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});;
		});
	},
	listCustomerInfoForCustomer({ commit }, item) {

		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Company/list/companyinfo/company/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("CUSTOMER_INFO_LIST_FOR_CUSTOMER", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	deleteCustomer({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.delete(sistemAddress + "api/uzumservice/Company/delete/company/" + item, {
						headers: {
							Authorization: `Bearer ${token}`
						}
					})
					.then(response => {
						commit("DELETE_ITEM_COMPANY", item)
						resolve(response);
					})
					.catch(err => {

						resolve(err.response);
					});
		});
	},
	deleteCustomerInfo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.delete(sistemAddress + "api/uzumservice/Company/delete/companyinfo/" + item, {
						headers: {
							Authorization: `Bearer ${token}`
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {

						resolve(err.response);
					});
		});
	},
	addEmployee({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.post(sistemAddress + "api/uzumservice/Company/add/employee", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {

						resolve(err.response);
					});
		});
	},
	listEmployeeForCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios.get(sistemAddress + "api/uzumservice/Company/list/employee/company/" + item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				}).then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("EMPLOYEE_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login")
					}
				}).catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});;
		});
	},
	updateEmployee({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.put(sistemAddress + "api/uzumservice/Company/update/employee", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	deleteEmployee({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) router.push("/login")
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.delete(sistemAddress + "api/uzumservice/Company/delete/employee/" + item, {
						headers: {
							Authorization: `Bearer ${token}`
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {

						resolve(err.response);
					});
		});
	},
}
